// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  title: {
    fontWeight: 600,
    fontSize: '14px',
  },
  sidebarIcon: {
    width: 24,
    height: 24,
  },
  searchWrapper: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      height: 36,
      fontSize: '13px',
      borderRadius: '18px',
      backgroundColor: theme.palette.grey[100],
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
  list: {
    flex: 1,
    overflow: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  layerItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
  },
  layerIcon: {
    fontSize: '18px',
    color: theme.palette.primary.main,
  },
  layerName: {
    fontSize: '13px',
    fontWeight: 500,
  },
  emptyText: {
    fontSize: '13px',
    color: theme.palette.grey[500],
    paddingTop: theme.spacing(2),
    textAlign: 'center' as const,
  },
});

export default styles;
